import { render, staticRenderFns } from "./SyncModal.vue?vue&type=template&id=45127ad0&"
import script from "./SyncModal.vue?vue&type=script&lang=ts&"
export * from "./SyncModal.vue?vue&type=script&lang=ts&"
import style0 from "./SyncModal.vue?vue&type=style&index=0&id=45127ad0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports